import "./WhatWeBuy.module.css";
import Header from "@/reusable_sections/Header";
import AnyHouseAnyCondition from "./sections/AnyHouseAnyCondition";
import CommonSellerSituations from "./sections/CommonSellerSituations";
import IgniteYourGrowth from "./sections/IgniteYourGrowth";
import CorporateFooter from "@/reusable_sections/Footer";
export default function WhatWeBuyPage() {
  return <div>
      <Header />
      <AnyHouseAnyCondition />
      <CommonSellerSituations />
      <IgniteYourGrowth />
      <CorporateFooter />
    </div>;
}